<div class="app-page">
  <!-- Header -->
  <div class="app-page-header">
    <h1 class="section-title">LT10</h1>
    <p class="section-subtitle">Sistema de Órdenes de Publicidad</p>
  </div>

  <!-- Main Content -->
  <div class="app-page-content">
    <div class="app-grid-cards">
      <!-- Usuarios Card -->
      @if (!shouldHideUsuariosCard) {
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/usuarios')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Usuarios</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona la información de tus usuarios
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>
      }

      <!-- Órdenes de Publicidad Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/ordenes')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Órdenes de Publicidad</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona las órdenes de publicidad
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Clientes Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/clientes')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Clientes</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona la información de tus clientes
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Tarifas Card -->
      @if (!shouldHideTarifasCard) {
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/tarifas')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Tarifas</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona las tarifas del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>
      }

      <!-- Programas Card -->
      @if (!shouldHideProgramasCard) {
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/programas')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Programas</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona los programas del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>
      }

      <!-- Programación Diaria Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/programacion-diaria')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3M3 11h18M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Programación diaria</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona la programación diaria de emisiones
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Rubros Card -->
      @if (!shouldHideRubrosCard) {
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/rubros')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Rubros</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona los rubros del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>
      }

      <!-- Tipos de Material Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/tipos-material')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Tipos de Material</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona los tipos de material del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Materiales Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/materiales')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Materiales</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona los materiales del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Tipos de Producto Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/tipo-productos')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Tipos de Producto</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona los tipos de producto del sistema
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Formatos Digitales Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/formatos-digitales')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h10M4 18h7" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Formatos Digitales</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona formatos para web y redes
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Ubicaciones Digitales Card -->
      <div
        class="app-card cursor-pointer group"
        (click)="navigateTo('/ubicaciones-digitales')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors"
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 21s7-4.35 7-11a7 7 0 10-14 0c0 6.65 7 11 7 11z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Ubicaciones Digitales</h3>
            <p class="text-sm mt-1 text-muted">
              Gestiona ubicaciones para campañas
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>

      <!-- Perfil Card -->
      <div 
        class="app-card cursor-pointer group"
        (click)="navigateTo('/profile')"
      >
        <div class="flex flex-col items-center text-center gap-4">
          <div class="w-16 h-16 rounded-xl flex items-center justify-center transition-colors" 
               style="background-color: hsl(var(--primary) / 0.1);">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="color: hsl(var(--primary));">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div>
            <h3 class="font-semibold text-lg" style="color: hsl(var(--text));">Mi Perfil</h3>
            <p class="text-sm mt-1 text-muted">
              Administra tu información personal
            </p>
          </div>
          <button class="font-medium text-sm hover:underline" style="color: hsl(var(--primary));">
            Abrir módulo →
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
